module.exports = __webpack_public_path__ + "static/welles-80e7ea52b88737ba4adbefc3cdb90c09.jpg";